var _circle, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOpenBlok(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    r: 7,
    transform: "matrix(-1 0 0 1 7 7)",
    fill: "#FABB00"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.82249 5.8325C4.97416 5.68083 5.21916 5.68083 5.37083 5.8325L6.87971 7.34139L8.3886 5.8325C8.54027 5.68083 8.78527 5.68083 8.93694 5.8325C9.0886 5.98417 9.0886 6.22917 8.93694 6.38083L7.15194 8.16583C7.00027 8.3175 6.75527 8.3175 6.6036 8.16583L4.8186 6.38083C4.67083 6.23306 4.67083 5.98417 4.82249 5.8325Z",
    fill: "#093C5D",
    stroke: "#093C5D",
    strokeWidth: 0.3
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenBlok);
export default __webpack_public_path__ + "static/media/openBlok.27fc4d35ccb6e5d43cc2d669c13a3a67.svg";
export { ForwardRef as ReactComponent };